import React from "react";
// import Header from "./Header";
import { Accordion, Container, Row } from "react-bootstrap";

function QuestionAnswers() {
  return (
    <>
      <Container className="mb-10">
        <Row>
          <h5 className="fw-bold text-center mb-4">
            Things You Should Know...
          </h5>
        </Row>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>1. What is mental health?</Accordion.Header>
            <Accordion.Body>
              Mental health is defined by the WHO as a state of wellbeing in
              which every individual realises his or her own potential, can cope
              with the normal stresses of life, can work productively and
              fruitfully and is able to make a contribution to their community.
              While it might sound complicated and wordy, this definition tells
              us that mental health is more than not having any symptoms of
              mental illness or discord; it's being able to deal robustly with
              life's challenges. Plus being able to take pleasure and
              satisfaction from life.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>2. What is mental illness?</Accordion.Header>
            <Accordion.Body>
              Mental illness includes a range of conditions for which there are
              standard criteria used to diagnose them, such as depression,
              anxiety and substance use disorders. A mental illness
              significantly affects how a person feels, thinks, behaves and
              interacts with other people.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              3. How many types of psychologists are there?
            </Accordion.Header>
            <Accordion.Body>
              "Psychologists specialise in a host of different areas within the
              field and identify themselves by many different labels. The field
              of psychology encompasses both research, through which we learn
              fundamental things about human and nonhuman animal behaviour, and
              practice, through which that knowledge is applied to solving
              problems and promoting healthy human development. In each of the
              subfields, there are psychologists who work primarily as
              researchers, others who work primarily as practitioners and many
              who do both (scientist-practitioners). Indeed, one of psychology's
              most unique and important characteristics is its coupling of
              science and practice, which stimulates the continual advancement
              of both. Additionally, many psychologists teach psychology in
              academic institutions, from high schools to graduate programs in
              universities." - APA
              <br />A few of them are:
              <ul>
                <li>Clinical Psychologist</li>
                <li>Counseling Psychologist</li>
                <li>Rehabilitation Psychologist</li>
                <li>School Psychologist </li>
                <li>Industrial/Organisational</li>
                <li>Educational Psychologist</li>
                <li>Sports Psychologist</li>
                <li>Forensic Psychologist</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              4. What are the different modalities in psychotherapy?
            </Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>
                  <b>Individual Therapy</b>: The client and the therapist meet
                  one-on-one. These meetings typically occur weekly. The amount
                  of time spent in therapy depends on the needs of the client as
                  well as their personal goals.
                </li>
                <li>
                  <b>Group Therapy</b>: The therapist meets together with
                  several clients with similar concerns. Sessions can be held
                  weekly/bi-weekly/monthly, depending on certain variables.
                </li>
                <li>
                  <b>Couples Therapy</b>: Couples therapy involves two people in
                  an intimate relationship who are having difficulties and are
                  trying to resolve them. The couple may be dating, partnered,
                  engaged, or married.
                </li>
                <li>
                  <b>Family Therapy</b>: Family therapy is a special form of
                  group therapy, consisting of one or more families.
                </li>
              </ul>{" "}
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>
              5. What happens in the therapeutic process?
            </Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>
                  It is a mutual relationship between the client and the
                  therapist. Building it is a continuous process.
                </li>
                <li>
                  The therapist and the client work together on the concerns
                  presented by the client.
                </li>
                <li>
                  Through the course of therapy, the client might go through
                  uncomfortable emotions as the thought processes are worked on
                  in detail.
                </li>
                <li>
                  The client learns new skills to cope better with future
                  challenges independently.
                </li>
                <li>
                  The course of therapy depends on the therapist's
                  specialization, approach, research and what specifically works
                  best for the client.
                </li>
                <li>The client's data is kept completely confidential.</li>
                <li>
                  The duration depends on the progress made session by session.
                </li>
                <li>
                  Progress depends on the work done in the sessions and outside
                  it.
                </li>
              </ul>{" "}
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5">
            <Accordion.Header>
              6. How can I know if I can benefit from psychotherapy?
            </Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>You don't know what's happening with you.</li>
                <li>You want a healthier life.</li>
                <li>
                  You feel an overwhelming, prolonged sense of helplessness and
                  sadness.
                </li>
                <li>
                  Your problems don't seem to get better despite your efforts
                  and help from loved ones.
                </li>
                <li>
                  You find it difficult to concentrate on work assignments or to
                  carry out everyday activities.
                </li>
                <li>
                  You worry excessively, expect the worst or are constantly on
                  an edge.
                </li>
                <li>You are having trouble in relationships in your life.</li>
                <li>You constantly find yourself overthinking.</li>
                <li>
                  Your substance usage is increasing and making you aggressive
                  or harmful to yourself and others.
                </li>
                <li>
                  Your body is showing unhealthy signs/symptoms like body ache,
                  headache, chest pain, dizziness, nausea, upset stomach, heart
                  palpitations.
                </li>
                <li>
                  You're experiencing changes in appetite and sleep cycles. You
                  constantly feel low on energy.
                </li>
                <li>
                  You feel unhappy or unfulfilled despite your achievements.
                </li>
              </ul>{" "}
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6">
            <Accordion.Header>
              7. Normal pre-first-session thoughts or feelings to have.
            </Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>“I don't know what will happen!”</li>
                <li>“I can't wait to see the therapist and talk about me.”</li>
                <li>“I hope this is helpful.”</li>
                <li>“I'm not sure where to start.”</li>
                <li>"What if someone finds out that I'm taking therapy."</li>
                <li>
                  “I don't care what others think, therapy is healthy and it's
                  for me."
                </li>
                <li>“I feel anxious/nervous.”</li>
                <li>“Maybe I shouldn't go or I should reschedule.”</li>
                <li>“I feel happy that I can talk to a professional.”</li>
                <li>
                  “It's better to find out what's happening now than later.”
                </li>
                <li>“This is good for me. This is the right step.”</li>
                <li>
                  “I deserve a safe and supportive space for me to talk and be
                  myself.”
                </li>
              </ul>
              <p>
                Note: It's normal to have these or other feelings and thoughts.
                Whether you're feeling scared, confused, motivated or anything
                else, in any case, you can let your therapist know about it for
                them to help you better.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="7">
            <Accordion.Header>
              8. Few things to remember about psychotherapy.
            </Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>It's not too late for you to go to therapy.</li>
                <li>Your worries are never 'too small' for therapy.</li>
                <li>Therapy might feel very weird at first.</li>
                <li>You don't have to sugarcoat things for your therapist.</li>
                <li>
                  It is okay to cry in therapy sessions. You don't have to
                  apologise for it.
                </li>
                <li>Your therapist cares about you.</li>
                <li>Therapy is self-discovery.</li>
                <li>
                  Give therapy and your therapist a chance (few sessions at
                  least). You can always change your therapist if you don't
                  connect well with them.
                </li>
                <li>
                  Your therapist isn't always right. You know your experience
                  the best. Tell them if they get it wrong.
                </li>
                <li>
                  It is okay to have disagreements in therapy and good to
                  provide feedback.
                </li>
                <li>
                  Good therapy sessions don't always feel 'good'! Some sessions
                  can feel uncomfortable.
                </li>
                <li>Therapy isn't a quick solution.</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    </>
  );
}

export default QuestionAnswers;
